import type { GridProps } from '@chakra-ui/react'
import { forwardRef } from '@chakra-ui/react'

import { useAuth } from '@/context/AuthContext'
import { useWaitingDiscountRequests } from '@/hooks/useOffer'
import type { PagedQuery } from 'BrokerTsLib/src/dtos'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { createContext, useEffect, useState } from 'react'
import { DashboardCard } from '../DashboardCard'
import { OverLimitDiscountRequestList } from './OverLimitDiscountRequestList'

export interface OverLimitsDscountCardProps extends GridProps { }

export const overLimitDiscountsContext = createContext<IPaginationContext<PagedQuery>>({} as IPaginationContext<PagedQuery>)

export const OverLimitDiscountRequestCard = forwardRef(
  ({ children, ...rest }: OverLimitsDscountCardProps, ref) => {
    const { user } = useAuth()!

    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(5)
    const [filter, setFilter] = useState<PagedQuery>({} as PagedQuery)

    const { data, mutateAsync, isLoading } = useWaitingDiscountRequests()
    const items = data?.data?.items ?? []

    useEffect(() => {
      setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
    }, [pageSize, currentPage])

    useEffect(() => {
      if (!user?.id) return

      if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
        mutateAsync(filter)
    }, [filter])


    return (
      <DashboardCard
        ref={ref}
        title="Žádosti o nadlimitní slevu"
        {...rest}
      >
        <overLimitDiscountsContext.Provider value={
          {
            loading: isLoading,
            totalCount: data?.data?.totalCount ?? 0,
            currentPage,
            pageSize,
            filter,
            setCurrentPage,
            setPageSize,
            updateFilter: setFilter,
            reload: () => mutateAsync(filter)
          }
        }>
          <OverLimitDiscountRequestList
            requests={items}
            loading={isLoading}
            withPaginator
          />
        </overLimitDiscountsContext.Provider>
      </DashboardCard>
    )
  },
)
